<header class="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16 md:h-20">
      <!-- Logo -->
      <div class="flex">
        <a routerLink="/" class="flex items-center space-x-2">
          <!-- <div class="w-24 h-12 md:w-28 md:h-14 bg-gradient-to-br from-orange-500 to-red-500 rounded-md flex items-center justify-center shadow-lg"> -->
          <img src="assets/img/capitalFoodLogo.png" class="w-24 h-12 md:w-28 md:h-14 rounded-md">
          <!-- </div> -->
          <!-- <div class="hidden sm:block">
              <h1 class="text-xl md:text-2xl font-bold text-gray-900">Capital</h1>
              <p class="text-xs text-orange-500 font-semibold -mt-1">FOOD</p>
            </div> -->
        </a>
        <div class="hidden md:flex items-center ml-8">
          <div class="flex items-center bg-gray-50 rounded-full px-4 py-2 border border-gray-200 min-w-[280px]">
            <span class="text-sm font-semibold text-gray-700 mr-2">DELIVERY</span>
            <div class="relative" #cityDropdown (click)="toggleCityDropdown()">
              <button class="flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors">
                <lucide-icon name="map-pin" class="w-4 h-4 mr-1 text-orange-500"></lucide-icon>
                {{ selectedCity }}
                <lucide-icon *ngIf="!showCityDropdown" name="chevron-down" class="w-4 h-4 ml-1"></lucide-icon>
                <lucide-icon *ngIf="showCityDropdown" name="chevron-up" class="w-4 h-4 ml-1"></lucide-icon>
              </button>
              <div *ngIf="showCityDropdown"
                class="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                <button *ngFor="let city of cities" (click)="selectCity(city)"
                  class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50">
                  {{ city }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Location Dropdown -->
      <!-- <div class="hidden md:flex items-center ml-8">
            <div class="flex items-center bg-gray-50 rounded-full px-4 py-2 border border-gray-200 min-w-[280px]">
              <span class="text-sm font-semibold text-gray-700 mr-2">DELIVERY</span>
              <div class="relative" (click)="toggleCityDropdown()">
                <button class="flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  <lucide-icon name="map-pin" class="w-4 h-4 mr-1 text-orange-500"></lucide-icon>
                  {{ selectedCity }}
                  <lucide-icon name="chevron-down" class="w-4 h-4 ml-1"></lucide-icon>
                </button>
                <div *ngIf="showCityDropdown" class="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  <button 
                    *ngFor="let city of cities" 
                    (click)="selectCity(city)"
                    class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
                  >
                    {{ city }}
                  </button>
                </div>
              </div>
            </div>
          </div> -->

      <!-- Desktop Navigation -->
      <nav class="hidden md:flex items-center space-x-6">
        <!-- <a routerLink="/about" class="text-sm font-medium text-gray-600 hover:text-orange-500 transition-colors">
              Why Capital Food?
            </a> -->
        <a routerLink="/offers"
          class="flex items-center text-sm font-medium text-gray-600 hover:text-orange-500 transition-colors">
          <lucide-icon name="gift" class="w-4 h-4 mr-1"></lucide-icon>
          Bulk Order
        </a>
        <!-- Deals -->
        <a routerLink="/cart"
          class="flex items-center text-sm font-medium text-gray-600 hover:text-orange-500 transition-colors relative">
          <lucide-icon name="shopping-cart" class="w-5 h-5 mr-1"></lucide-icon>
          Cart
          <span *ngIf="cartCount > 0"
            class="absolute -top-2 -right-2 bg-orange-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
            {{ cartCount }}
          </span>
        </a>
        <!-- <button class="rounded-full border border-gray-300 px-4 py-2 text-sm font-medium hover:border-orange-500 hover:text-orange-500 transition-all">
              Get the app
            </button> -->
        <button *ngIf="showSignIn == true"
          class="rounded-full bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 text-sm font-medium transition-all"
          (click)="loginClick()">
          Sign in
        </button>

        <div *ngIf="!showSignIn" class="relative">
          <!-- Dropdown Trigger -->
          <button (click)="isMenuOpen = !isMenuOpen"
            class="flex items-center space-x-2 p-1 pr-3 rounded-full hover:bg-gray-100 transition-all border border-transparent hover:border-gray-200">
            <div
              class="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold text-xs">
              {{ name | slice:0:1 | uppercase }}
            </div>
            <span class="text-sm font-semibold text-gray-700">{{ name }}</span>
            <lucide-icon [name]="isMenuOpen ? 'chevron-up' : 'chevron-down'"
              class="w-4 h-4 text-gray-400"></lucide-icon>
          </button>

          <!-- Dropdown Menu (Pure Tailwind) -->
          <div *ngIf="isMenuOpen" (clickOutside)="isMenuOpen = false"
            class="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 py-2 z-50 animate-in fade-in zoom-in duration-200">

            <p class="px-4 py-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Account Settings</p>

            <a [routerLink]="['/profile']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="user" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Profile
            </a>

            <a [routerLink]="['/order-history']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="history" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Order history
            </a>

            <a [routerLink]="['/payment-history']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="history" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Payment history
            </a>

            <div class="my-2 border-t border-gray-100"></div>

            <button (click)="logout(false); isMenuOpen = false"
              class="w-full flex items-center px-4 py-2.5 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors">
              <lucide-icon name="log-out" class="w-4 h-4 mr-3"></lucide-icon> Logout
            </button>
          </div>
        </div>

        <!-- Transparent overlay to close dropdown when clicking outside -->
        <div *ngIf="isMenuOpen" class="fixed inset-0 z-40" (click)="isMenuOpen = false"></div>
      </nav>

      <!-- Mobile Menu Button -->
      <div class="flex md:hidden items-center space-x-3">
        <a routerLink="/cart" class="relative p-2">
          <lucide-icon name="shopping-cart" class="w-6 h-6 text-gray-700"></lucide-icon>
          <span *ngIf="cartCount > 0"
            class="absolute top-0 right-0 bg-orange-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
            {{ cartCount }}
          </span>
        </a>
        <button (click)="toggleMobileMenu()" class="p-2 text-gray-700">
          <lucide-icon [name]="mobileMenuOpen ? 'x' : 'menu'" class="w-6 h-6"></lucide-icon>
        </button>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div *ngIf="mobileMenuOpen" class="md:hidden py-4 border-t border-gray-100">
      <div class="flex items-center bg-gray-50 rounded-lg px-2 py-3">
        <!-- <lucide-icon name="map-pin" class="w-4 h-4 mr-2 text-orange-500"></lucide-icon>
            <span class="text-sm text-gray-600">{{ selectedCity }}</span> -->
        <div class="flex items-center bg-gray-50 rounded-full px-4 py-2 border border-gray-200 min-w-[230px]">
          <span class="text-sm font-semibold text-gray-700 mr-2">DELIVERY</span>
          <div class="relative" #cityDropdown (click)="$event.stopPropagation(); toggleCityDropdown()">
            <button class="flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors">
              <lucide-icon name="map-pin" class="w-4 h-4 mr-1 text-orange-500"></lucide-icon>
              {{ selectedCity }}
              <lucide-icon *ngIf="!showCityDropdown" name="chevron-down" class="w-4 h-4 ml-1"></lucide-icon>
              <lucide-icon *ngIf="showCityDropdown" name="chevron-up" class="w-4 h-4 ml-1"></lucide-icon>
            </button>
            <div *ngIf="showCityDropdown"
              class="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
              <button *ngFor="let city of cities" (click)="selectCity(city)"
                class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50">
                {{ city }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <nav class="space-y-3">
        <!-- <a routerLink="/about" (click)="mobileMenuOpen = false" class="block px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg">
              Why Capital Food?
            </a> -->
        <a routerLink="/offers" (click)="mobileMenuOpen = false"
          class="block px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg">
          Bulk Order
        </a>
        <a routerLink="/contact" (click)="mobileMenuOpen = false"
          class="block px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg">
          Contact Us
        </a>
        <div class="pt-3 px-4">
          <button class="w-full rounded-full bg-orange-500 hover:bg-orange-600 text-white py-2 font-medium">
            Sign in
          </button>
        </div>
      </nav>
    </div>
  </div>
</header>
<!-- routerLinkActive="border-b-2 border-teal-600"
   [routerLinkActiveOptions]="{ exact: true }" -->